import Component from './button'

export default Component